<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="titlepage_title">Anonymous </p>
<p class="titlepage_title2">No More</p>
<p class="titlepage_subtitle">ONE MOTHER’S FAITH-FILLED JOURNEY THROUGH ADDICTION, RECOVERY</p>
<p class="titlepage_subtitle2">&amp; REDEMPTION</p>
<p class="titlepage_author">ALISA MASSEY</p>
<p class="titlepage_logo"><img alt="MJ logo" class="_idGenPageitem-1" src="image/MJ_icon_black.jpg"/></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781630472863_EPUB.vue?180a1e5e